import app from 'flarum/forum/app';

const channel = new BroadcastChannel("qq_auth");
const authStateWindows: Record<string, WindowProxy> = {};

window.addEventListener("message", (e: MessageEvent) => {
    switch (e.data?.type) {
        case "qq_unlink":
            if (e.data?.result)
                window.location.reload();
            break;
        case "qq_auth_state":
            authStateWindows[e.data?.state] = e.source as WindowProxy;
            break;
    }
});

channel.addEventListener("message", (e: MessageEvent) => {
    if (!(e.data?.state in authStateWindows)) return;
    if (e.data?.loggedIn) {
        authStateWindows[e.data?.state]?.close();
        window.location.reload();
    }
});

function showAuthPopup(path: string, name = "logInPopup") {
    const width = 580;
    const height = 400;
    const $window = $(window);

    window.open(
        app.forum.attribute('baseUrl') + path,
        name,
        `width=${width},` +
        `height=${height},` +
        `top=${$window.height()! / 2 - height / 2},` +
        `left=${$window.width()! / 2 - width / 2},` +
        'status=no,scrollbars=yes,resizable=no'
    );
}

export function authQQ() {
    showAuthPopup("/auth/qq");
}

export function linkQQ() {
    showAuthPopup("/link/qq", "linkPopup");
}

export function unlinkQQ() {
    showAuthPopup("/unlink/qq", "linkPopup");
}
